export class PopupManager {
    constructor(config) {
        
        this.config = {
            // Element selectors
            triggerSelector: config.triggerSelector,
            popupSelector: config.popupSelector,
            backgroundSelector: config.backgroundSelector,
            closeSelector: config.closeSelector,
            focusOnOpenSelector: config.focusOnOpenSelector,

            // Callbacks
            onOpen: config.onOpen || (() => {}),
            onClose: config.onClose || (() => {}),
        };

        this.isOpen = false;
        this.lastFocusedElement = null;

        // Focus elements for trapping
        this.focusableElements = null;
        this.topFocusLimit = null;
        this.bottomFocusLimit = null;
        
        // Bind event handlers
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleFocusLimitFocus = this.handleFocusLimitFocus.bind(this);

        this.init();
    }

    init() {
        this.setupEventListeners();
    }

    setupEventListeners() {
        if (this.config.triggerSelector) {
            $(document).on('click', this.config.triggerSelector, (event) => {
                event.preventDefault();
                this.lastFocusedElement = event.currentTarget;
                this.open();
            });
        }
    }

    addPopupEventListeners() {
        $(document).on('click', this.config.closeSelector, this.closePopup);

        if (this.config.backgroundSelector) {
            $(document).on('click', this.config.backgroundSelector, this.closePopup);
        }

        $(document).on('keydown', this.handleKeydown);
    }

    removePopupEventListeners() {
        $(document).off('click', this.config.closeSelector, this.closePopup);
        
        if (this.config.backgroundSelector) {
            $(document).off('click', this.config.backgroundSelector, this.closePopup);
        }
        
        $(document).off('keydown', this.handleKeydown);
    }

    closePopup = (event) => {
        event.preventDefault();
        this.close();
    }

    setInitialFocus() {
        if (this.config.focusOnOpenSelector) {
            setTimeout(() => {
                const $popup = $(this.config.popupSelector);
                const $focusElement = $popup.find(this.config.focusOnOpenSelector);
                if ($focusElement.length) {
                    $focusElement.focus();
                }
            }, 100); // Ensure popup is visible
        }
    }

    open() {
        if (this.isOpen) return;

        const $popup = $(this.config.popupSelector);
        const $background = this.config.backgroundSelector ? $(this.config.backgroundSelector) : null;

        $popup.addClass('is-active');
        if ($background) {
            $background.addClass('is-active');
        }

        if (this.lastFocusedElement) {
            $(this.lastFocusedElement).attr('aria-expanded', 'true');
        }

        $popup.attr({
            'aria-modal': 'true',
            'role': 'dialog'
        });

        this.isOpen = true;

        this.addPopupEventListeners();
        
        this.setupFocusTrap();

        this.setInitialFocus();

        // Call optional custom onOpen callback
        this.config.onOpen($popup, $background);
    }

    close() {
        if (!this.isOpen) return;

        const $popup = $(this.config.popupSelector);
        const $background = this.config.backgroundSelector ? $(this.config.backgroundSelector) : null;

        this.removePopupEventListeners();

        this.removeFocusLimits();

        $popup.removeClass('is-active');
        if ($background) {
            $background.removeClass('is-active');
        }

        if (this.lastFocusedElement) {
            $(this.lastFocusedElement).attr('aria-expanded', 'false');
        }

        $popup.removeAttr('aria-modal role');

        this.isOpen = false;

        if (this.lastFocusedElement) {
            setTimeout(() => {
                $(this.lastFocusedElement).focus();
            }, 100);
        }

        // Call optional custom onClose callback
        this.config.onClose($popup, $background);
    }

    handleKeydown(event) {
        switch (event.key) {
            case 'Escape':
                event.preventDefault();
                this.close();
                break;
        }
    }

    setupFocusTrap() {
        const $popup = $(this.config.popupSelector);
        
        this.focusableElements = $popup.find(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        ).filter(':visible');

        if (this.focusableElements.length > 0) {
            this.createFocusLimits();
        }
    }

    createFocusLimits() {
        const $popup = $(this.config.popupSelector);
        
        // Create focus limit elements
        this.topFocusLimit = $('<div tabindex="0" class="u-visually-hidden" aria-hidden="true"></div>')[0];
        this.bottomFocusLimit = $('<div tabindex="0" class="u-visually-hidden" aria-hidden="true"></div>')[0];

        // Add as first and last elements of the popup
        $popup.prepend(this.topFocusLimit);
        $popup.append(this.bottomFocusLimit);

        // Add focus listeners
        $(this.topFocusLimit).on('focus', this.handleFocusLimitFocus);
        $(this.bottomFocusLimit).on('focus', this.handleFocusLimitFocus);
    }

    removeFocusLimits() {
        if (this.topFocusLimit) {
            $(this.topFocusLimit).off('focus', this.handleFocusLimitFocus);
            $(this.topFocusLimit).remove();
            this.topFocusLimit = null;
        }
        
        if (this.bottomFocusLimit) {
            $(this.bottomFocusLimit).off('focus', this.handleFocusLimitFocus);
            $(this.bottomFocusLimit).remove();
            this.bottomFocusLimit = null;
        }
    }

    refreshFocusTrap() {
        if (!this.isOpen) {
            return;
        }
        
        this.removeFocusLimits();
        
        // Re-scan for focusable elements and create new limits
        this.setupFocusTrap();
    }

    handleFocusLimitFocus(event) {
        if (!this.focusableElements || this.focusableElements.length === 0) return;

        const firstElement = this.focusableElements[0];
        const lastElement = this.focusableElements[this.focusableElements.length - 1];

        if (event.target === this.topFocusLimit) {
            lastElement.focus();
        } else if (event.target === this.bottomFocusLimit) {
            firstElement.focus();
        }
    }
}
